import React from "react";
import clsx from "clsx";
import type { Filter } from "./tableLogic";

type FilterChipsProps = {
  filters: Filter[];
  onRemove: (id: string) => void;
  onClearAll: () => void;
};

const FilterChips: React.FC<FilterChipsProps> = ({ filters, onRemove, onClearAll }) => {
  if (filters.length === 0) return null;
  return (
    <div
      className={clsx(
        "mb-3 flex items-center gap-3" // filter-chips-row
      )}
    >
      {filters.map(f => (
        <span
          key={f.col}
          className={clsx(
            "inline-flex items-center bg-gray-200 rounded-full px-3 py-1 text-sm mr-1" // filter-chip
          )}
        >
          {`${f.col} ${f.op} ${f.value}`}
          <button
            onClick={() => onRemove(f.col)}
            className={clsx(
              "ml-2 bg-transparent border-none cursor-pointer font-bold text-gray-500 text-base leading-none" // filter-chip-remove
            )}
            title="Remover filtro"
            aria-label={`Remover filtro de ${f.col}`}
            type="button"
          >
            ×
          </button>
        </span>
      ))}
      <button
        onClick={onClearAll}
        className={clsx(
          "px-4 py-1 rounded border border-gray-300 bg-gray-100 cursor-pointer font-bold" // filter-chip-clearall
        )}
        title="Remover todos os filtros"
        type="button"
      >
        Limpar todos
      </button>
    </div>
  );
};

export default FilterChips;